import React from "react";
import styled from "styled-components";
import { Box, Text } from "@thinkingmachines/asimov";
const CircleLegend = styled.div `
  background: ${(props) => props.color};
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-top: auto;
  margin-bottom: auto;
`;
const LegendContainer = styled.div `
  margin-top: auto;
  margin-bottom: autoj
  margin-left: 5px;
  margin-right: 10px;
`;
const TextContainer = styled.div `
  margin: auto 0px;
`;
const TitleSubtitle = ({ title, subtitle }) => {
    return (React.createElement(Box, null,
        React.createElement(Text, { fontSize: "14px", fontWeight: "bold" }, title),
        subtitle ? (React.createElement(Text, { fontSize: "12px", color: "gray.0" }, subtitle)) : null));
};
const Label = ({ label }) => (React.createElement(Box, { flexDirection: "row", padding: "2px" },
    React.createElement(LegendContainer, null, label.icon ? React.createElement(label.icon, null) : React.createElement(CircleLegend, { color: label.color })),
    React.createElement(TextContainer, null,
        React.createElement(Text, { fontSize: "12px" }, label.text))));
/**
 * Simple component for presenting legends. `title`, `subtitle`, and `labels` property can be the defined
 */
export const Legend = ({ title, subtitle, labels }) => (React.createElement(React.Fragment, null,
    React.createElement(TitleSubtitle, { title: title, subtitle: subtitle }),
    labels.map((label, key) => (React.createElement(Label, { key: key, label: label })))));
/**
 * A more complex legends that allows division of legends into different categories.
 */
export const MultiLegends = ({ legends }) => (React.createElement(React.Fragment, null, legends.map((legend, key) => (React.createElement(Box, { key: key },
    React.createElement(TitleSubtitle, { title: legend.title, subtitle: legend.subtitle }),
    legend.labels.map((label, key) => (React.createElement(Label, { key: key, label: label }))))))));
//# sourceMappingURL=Legends.js.map